module.exports = __webpack_public_path__ + "cpu-iso2.png?7eee251024f7a4bac4d1dff22cfbaf30";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/cpu-iso2.png
// module id = 139
// module chunks = 0